export class ProductChild {
    id = 0;
    product_id = 0;
    color_id = 0;
    size_id = 0;
    material_id = 0;
    cost = 0;
    price = 0;
    price_two = 0;
    stock = 0;
}
